import { Component, OnInit } from '@angular/core';
import { VTabComponent } from '@app/directives/_layout/v-tabs/v-tab.component';
import { IAccountUnitMappingExtended } from '@app/interfaces/IAccountUnitMappingExtended';
import { IUnit } from '@app/interfaces/IPeripheral';
import { IVehicleUnitMapping } from '@app/interfaces/IVehiclePeripheralMapping';
import { UnitsService } from '@app/main/modules/foundation/_services/unit.service';
import { NavigationService } from '@app/services/navigation.service';
import { ResourceType } from "@enums/ResourceType";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HardwareMappingService } from '../../_services/hardware-mapping.service';
import './unit-view.component.scss';

@UntilDestroy()
@Component({
    selector: 'unit-view',
    template: require('./unit-view.component.html')
})
export class UnitViewComponent implements OnInit {
    unitSerial: string;
    unit: IUnit;
    vehicleMapping: IVehicleUnitMapping;

    accountUnitMappings: IAccountUnitMappingExtended[];
    accountId: number;

    selectedTab: VTabComponent;

    resourceType = ResourceType;

    loading: boolean;

    constructor(
        private readonly hardwareMappingService: HardwareMappingService,
        private readonly navigationService: NavigationService,
        private readonly unitService: UnitsService,
    ) { }

    ngOnInit(): void {
        this.unitSerial = this.navigationService.getRouteParam("unitSerial");
        this.loadData();
    }

    onTabSelected(tab: VTabComponent): void {
        this.selectedTab = tab;
    }

    //--

    private loadData(): void {
        this.loading = true;

        this.unitService.getUnitBySerialWithMappings(this.unitSerial)
            .pipe(
                untilDestroyed(this))
            .subscribe(units => {
                this.unit = units.find(u => u.Serial == this.unitSerial);
                this.getAccountMapping();
                this.loading = false
            })
    }

    private getAccountMapping(): void {
        this.hardwareMappingService.getAccountMappings(this.unit.Serial).pipe(untilDestroyed(this)).subscribe(mappings => {
            this.accountUnitMappings = mappings;
            this.accountId = this.accountUnitMappings[this.accountUnitMappings.length - 1]?.AccountId;
        })
    }

}
